import { useEffect, useState } from "react";
import { logDataToConsole } from "../../../utils/customLogger";
import { fetchLatestCmmScreenshotUrl } from "../../cmmOrder/utils/fetchCmmDocument";

export const useOutcomeDocument = (orderId: string | undefined) => {
  const [screenshotUrl, setScreenshotUrl] = useState<string | null>(null);
  const [isFetchingDoc, setIsFetchingDoc] = useState<boolean>(false);
  const [errorInFetching, setErrorInFetching] = useState<boolean>(false);
  const [noDocumentFound, setNoDocumentFound] = useState<boolean>(false);

  useEffect(() => {
    if (!orderId) return;

    const fetchScreenshot = async () => {
      setIsFetchingDoc(true);
      setErrorInFetching(false);
      setNoDocumentFound(false);
      try {
        const url = await fetchLatestCmmScreenshotUrl(orderId);
        if (url) {
          setScreenshotUrl(url);
        } else {
          setNoDocumentFound(true);
        }
      } catch (err) {
        logDataToConsole("Error fetching CMM screenshot for outcome", err);
        setErrorInFetching(true);
      } finally {
        setIsFetchingDoc(false);
      }
    };

    fetchScreenshot();
  }, [orderId]);

  return { screenshotUrl, isFetchingDoc, errorInFetching, noDocumentFound };
};
